import React from "react";
import Icon from "components/AppIcon";

const ACTIVITY_ICONS = {
  trade: { icon: "BarChart2", color: "var(--color-primary)" },
  crime: { icon: "Skull", color: "var(--color-accent)" },
  faction: { icon: "Users", color: "var(--color-success)" },
  business: { icon: "Building2", color: "var(--color-warning)" },
  system: { icon: "Bell", color: "var(--color-muted-foreground)" },
};

const ActivityFeed = ({ activities, isLive }) => {
  return (
    <div
      className="rounded-xl border border-border p-4 md:p-5"
      style={{ background: "var(--color-card)" }}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={15} color="var(--color-primary)" />
          <h3 className="font-heading text-sm font-semibold text-foreground">Recent Activity</h3>
          {isLive && (
            <span
              className="flex items-center gap-1 font-caption text-xs px-1.5 py-0.5 rounded"
              style={{
                background: 'rgba(16,185,129,0.08)',
                border: '1px solid rgba(16,185,129,0.2)',
                color: 'var(--color-success)',
              }}
            >
              <span className="w-1 h-1 rounded-full animate-pulse" style={{ background: 'var(--color-success)' }} />
              Live
            </span>
          )}
        </div>
        <span className="font-caption text-xs text-muted-foreground">
          {activities?.length || 0} events
        </span>
      </div>
      <div className="space-y-1 max-h-72 overflow-y-auto pr-1">
        {activities?.map((act) => {
          const meta = ACTIVITY_ICONS?.[act?.type] || ACTIVITY_ICONS?.system;
          return (
            <div
              key={act?.id}
              className={`flex items-start gap-3 p-2.5 rounded-lg transition-all duration-300 ${
                act?.isNew
                  ? 'bg-primary/8 border border-primary/15' :'hover:bg-primary/5'
              }`}
              style={{
                animation: act?.isNew ? 'slideInActivity 0.35s ease-out' : undefined,
              }}
            >
              <div
                className="w-7 h-7 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5"
                style={{ background: `${meta.color}15` }}
              >
                <Icon name={meta.icon} size={13} color={meta.color} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5">
                  <p className="font-caption text-xs text-foreground leading-snug">{act?.message}</p>
                  {act?.isNew && (
                    <span
                      className="font-caption text-xs px-1 py-0.5 rounded flex-shrink-0"
                      style={{
                        background: 'rgba(0,217,255,0.1)',
                        color: 'var(--color-primary)',
                        fontSize: '9px',
                      }}
                    >
                      NEW
                    </span>
                  )}
                </div>
                {act?.detail && (
                  <p
                    className="font-caption text-xs mt-0.5"
                    style={{
                      color:
                        act?.outcome === "success" ? "var(--color-success)"
                          : act?.outcome === "failure" ? "var(--color-error)" : "var(--color-muted-foreground)",
                    }}
                  >
                    {act?.detail}
                  </p>
                )}
              </div>
              <span className="font-caption text-xs text-muted-foreground flex-shrink-0 whitespace-nowrap">
                {act?.time}
              </span>
            </div>
          );
        })}
        {(!activities || activities?.length === 0) && (
          <p className="font-caption text-xs text-muted-foreground text-center py-4">
            No recent activity
          </p>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;